export enum Declination {
  Nominative,
  Accusative,
  Dative,
  Genitive,
  Instrumental,
  Prepositional,
}
